
import { defineComponent } from '@vue/composition-api';
import { ORCID_BASE_URL } from '@/util';

export default defineComponent({
  props: {
    width: {
      type: Number,
      default: 16,
    },
    name: {
      type: String,
      default: '',
    },
    orcidId: {
      type: String,
      required: true,
    },
    authenticated: {
      type: Boolean,
      required: true,
    },
    orcidBaseUrl: {
      type: String,
      default: ORCID_BASE_URL,
    },
  },
});
